import merge from "lodash/merge";

import de from "./de.json";
import enAu from "./en-au.json";
import enUs from "./en-us.json";
import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import it from "./it.json";
import ru from "./ru.json";

const locales = {
  de,
  "en-au": enAu,
  "en-us": enUs,
  en,
  es,
  fr,
  it,
  ru
};

const getLanguageBundle = bundle => locales[bundle] || {};

export default languageCode => {
  const [lang] = languageCode.split("-");
  return merge(
    {},
    getLanguageBundle(lang),
    getLanguageBundle(languageCode.toLowerCase())
  );
};



// WEBPACK FOOTER //
// ../i18n/index.js